import { Navigate } from 'react-router-dom'
import { useAuth } from '@/modules/auth'
import { isRestorablePath } from '@/shared/utils/auth'
import { FullPageSkeleton } from '@/ui/components'

interface PublicRouteProps {
  children: React.ReactNode
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { user, isAuthenticated, isBetaUser, isLoading } = useAuth()

  // Show loading spinner while auth is initializing
  if (isLoading) {
    return <FullPageSkeleton />
  }

  // If user is authenticated, redirect to last visited route if available, otherwise dashboard
  // Exception: Beta users can access the landing page (handled by ConditionalLandingRoute)
  if (user && isAuthenticated) {
    // Don't redirect if they're on the landing page and are a beta user
    const currentPath = window.location.pathname
    if (currentPath === '/' && isBetaUser) {
      return <>{children}</>
    }
    
    try {
      const redirectParam = new URLSearchParams(window.location.search).get('redirect')
      const isValidRedirect = redirectParam && redirectParam.startsWith('/') && !redirectParam.startsWith('//')
      if (isValidRedirect) {
        return <Navigate to={redirectParam} replace />
      }
      const last = sessionStorage.getItem('last_pathname')
      if (isRestorablePath(last)) {
        return <Navigate to={last} replace />
      }
    } catch {}
    return <Navigate to="/dashboard" replace />
  }

  // If not authenticated, show the public content
  return <>{children}</>
}
